export type PayableRow = {
  affiliate_user_id: string;
  currency: string;
  payable_cents: number;
  commission_count: number;
  meets_minimum: boolean;
};

export type PayoutBatchRow = {
  id: string;
  affiliate_user_id: string;
  currency: string;
  total_amount_cents: number;
  commission_count: number;
  payment_reference: string | null;
  notes: string | null;
  paid_at: string;
  created_at: string;
};

export type TaxStatus = { status: string; expires_at: string | null } | null;

function csvEscape(value: string): string {
  if (/[",\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

export function downloadCsv(filename: string, rows: string[][]) {
  const csv = rows.map((r) => r.map((c) => csvEscape(String(c))).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
